import util from '@bmp-vue/core/api/util'

const url = 'Autenticacao'

export default Object.assign({}, util.GetCrud(url, null), {
  Autenticar(credenciais) {
    localStorage.setItem("userDocument", credenciais.documento); // Salva localmente o documento para usar nas consultas
    const dto = { Username: credenciais.documento, Password: credenciais.password, CaptchaToken: credenciais.captchaToken };
    return util.Axios.Post(url + '/Token', dto);
  },
  Logout() {
    return new Promise(resolve => {
      resolve('');
    });
  },
  RefreshToken() {
    const { refreshToken, token } = JSON.parse(localStorage.getItem('user'));
    const dto = {
      token: refreshToken
    };

    return util.Axios.Post(url + '/Token/Refresh', dto, null, token);
  },
  ResetSenha(dto) {
    return util.Axios.Post(url + '/Token/Password/Reset', dto, null);
  },
  ValidarTokenResetSenha(dto) {
    return util.Axios.Post(url + '/Token/Password/Validate', dto, null);
  },
  SolicitarTokenResetSenha(dto) {
    return util.Axios.Post(url + '/Token/Password', dto, null);
  }
});
